import {KinesisEvent} from "../kinesis.event";
import {KINESIS} from "../../kinesis.consts";

export class VisitKinesisEvent extends KinesisEvent {
  constructor() {
    super(KINESIS.CATEGORY.bolao, KINESIS.ACTION.visit);
  }
}
